import {withDialogActions} from './withDialogActions';
import {DialogActionsStyle} from './DialogActionsStyle';

/**
 * Component that is located at the bottom of a Dialog.
 * Generally contains buttons.
 *
 * @component
 */
export const DialogActions = withDialogActions(DialogActionsStyle);
